export enum HOME_CONSTANTS {
  STEP1 = 'STEP 1 / 3 (required):',
  STEP2 = 'STEP 2 / 3 (optional):',
  STEP3 = 'STEP 3 / 3 (optional):',
  SELECT_EXTRAS = 'Select extras',
  NEW_LEASE = 'New Booking',
  SELECT_ROOM = 'Select room',
  CHANGE_LOCATION = 'Change Location',
  MAIN_LEASES = 'Main Bookings',
  OTHERS = 'Others',
  ROOMS = 'Rooms',
  PACKAGES = 'Packages',
  MAILBOX_LEASES = 'Mailbox Bookings',
  SHORT_TERM_BOOKING = 'Short Term Booking',
  MEDIUM_TERM_BOOKING = 'Medium Term Booking',
  LONG_TERM_BOOKING = 'Long Term Booking',
}

export enum NewLeasesTypes {
  RoomLease = 'Room',
  // MailboxLease = 'Mailbox',
  // StorageLease = 'Storage',
  // LockerLease = 'Locker lease',
  // MedicalLease = 'Medical lease',
}
